
import _ from 'lodash'
import IssueMapper from 'shared_src/mappings/issue'

import Choices from './IssueMapping/Choices'
import Exam from './IssueMapping/Exam'
import Expectations from './IssueMapping/Expectations'

const MAPPING = {
  standardpeexam: Exam,
  standardexpectations: Expectations,
  standardgoalschoices: Choices
}

const collectIssues = mapping => {
  const { issues } = mapping
  if (issues) {
    return issues.map(issue => _.pick(issue, [ 'id', 'domain' ]))
  }
  return Object.values(mapping).reduce(
    (acc, value) => acc.concat(collectIssues(value)),
    []
  )
}

export const sidebarWrapper = (sidebar, location) => {
  const { open, filters } = sidebar
  const { pathname } = location
  const active = pathname && _.last(pathname.split('/'))
  const mapping = MAPPING[active] || {}
  const issues = collectIssues(mapping)
  const visible = !_.isEmpty(issues)
  return {
    open,
    filters,
    issues,
    visible
  }
}

const esasTrend = level => {
  const label = {
    none: 'NON',
    mild: 'MLD',
    moderate: 'MOD',
    severe: 'SEV',
    unbearable: 'UNB'
  }
  const className = [ 'esas-trend' ]
  className.push(_.toLower(level))
  return <span className={className.join(' ')}>{label[_.toLower(level)]}</span>
}

const esasChangeTrend = (before, after) => {
  if (!before && !after) {
    return null
  }
  if (before && !after) {
    return esasTrend(before)
  }
  return (
    <div className='esas-trend-container'>
      {esasTrend(before)}
      <i className='fa fa-arrow-right' />
      {esasTrend(after)}
    </div>
  )
}

const esasMap = esasData => {
  const obj = {}
  esasData.forEach(dataObj => {
    Object.keys(dataObj).forEach(key => {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        let { before, after } = obj[key]
        if (!after) {
          after = before
        }
        obj[key].before = after
        obj[key].after = dataObj[key]
      } else {
        obj[key] = { before: dataObj[key] }
      }
    })
  })
  const results = {}
  const resultsKeys = Object.keys(obj)
  resultsKeys.forEach(k => {
    if (k && k.includes('Category')) {
      const newKey = k.substring(0, k.indexOf('C'))
      results[newKey] = obj[k]
    }
  })
  return results
}

const pairIssuesAndGoals = ({ careplans, goals, encounterId }) =>
  _.map(careplans, issue => {
    const goalId = _.get(issue, 'goal[0].reference', '').split('/')[1]

    if (!goalId || !goals[goalId]) {
      console.warn('Missing Goal for CarePlan, skipping it', issue)
      return null
    }

    let modified = false
    if (issue.extension && issue.extension.length) {
      const modifiedIdentifier = _.get(issue, 'extension').find(i => {
        if (
          _.get(i, 'url') ===
          'http://narushealth.com/fhir/issue-last-modified-ecnounter'
        ) {
          return i
        }
        return null
      })

      const lastModifiedEncounter = modifiedIdentifier
        ? modifiedIdentifier.valueString
        : ''
      modified = lastModifiedEncounter === encounterId
    }
    return {
      issue,
      goal: goals[goalId],
      modified
    }
  })

export const getRows = ({
  issueFilters,
  careplans,
  goals,
  encounterId,
  esasData
}) => {
  const esas = esasMap(esasData)

  const issueAndGoalPairs = pairIssuesAndGoals({
    careplans,
    goals,
    encounterId
  })
  let issues = _.compact(issueAndGoalPairs).map(r => {
    const domainId = _.get(r, 'issue.identifier').find(i => {
      if (_.get(i, 'type.text') === 'DomainID') {
        return i
      }
      return null
    })?.value

    if (domainId === 'DPS') {
      const esasKeys = Object.keys(esas)
      let esasDescription
      esasKeys.forEach(k => {
        if (_.get(r, 'issue.description').includes(k)) {
          // eslint-disable-next-line react/display-name
          esasDescription = () => (
            <div className='esas-description-container'>
              {_.get(r, 'issue.description')}
              {esasChangeTrend(esas[k].before, esas[k].after)}
            </div>
          )
        }
      })
      return {
        ...r,
        esasDescription
      }
    }
    return r
  })

  issues = _.map(issues, i => {
    const urgent =
      _.findIndex(
        i.issue.extension,
        e => e.url === IssueMapper.IssueExtensions.urgent && e.valueBoolean
      ) > -1
    return {
      ...i,
      urgent
    }
  })

  const filteredIssues = issues.filter(
    i => issueFilters.indexOf(i.issue.status) >= 0
  )

  return filteredIssues
}

export const countIssuesByStatus = ({ careplans }) => {
  const counts = _.reduce(
    careplans,
    (counters, issue) => {
      const status = _.get(issue, 'status')
      const res = { ...counters }
      if (_.has(res, status)) {
        res[status] += 1
      } else {
        res[status] = 1
      }
      return res
    },
    {}
  )
  return counts
}
